import './style.scss';

import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { Dropdown, Icon } from 'semantic-ui-react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { setDevicePath } from 'app/redux/xrayGeneratorConfiguration/actions';
import { XRayGeneratorStateContext } from 'app/providers/XRayGeneratorProvider';
import { selectXRayConfiguration } from 'app/redux/xrayGeneratorConfiguration/reducer';
import XRayGeneratorManagerContext from 'app/providers/XRayGeneratorManagerProvider/context';
import TechnicianPasswordValidationContext from 'app/providers/TechnicianPasswordValidationProvider/context';

function XRayGeneratorConfiguration() {
  const xRayGeneratorManager = useContext(XRayGeneratorManagerContext);

  const [serialDevicesOptions, setSerialDevicesOptions] = useState([]);
  const dispatch = useDispatch();
  const intl = useIntl();
  const { connectionState } = useContext(XRayGeneratorStateContext);
  const requestValidation = useContext(TechnicianPasswordValidationContext);
  const xRayConfiguration = useSelector(selectXRayConfiguration);
  const { devicePath = null } = xRayConfiguration;

  const onOptionSelect = useCallback(
    (event, { value }) =>
      requestValidation()
        .then(() => dispatch(setDevicePath(value ? value : undefined)))
        .catch(() => {}),
    [dispatch, requestValidation]
  );

  useEffect(() => {
    xRayGeneratorManager
      .list()
      .then((xrayGeneratorHandles) =>
        setSerialDevicesOptions(
          xrayGeneratorHandles.map(({ id }) => ({ key: id, value: id, text: id }))
        )
      );
  }, []);

  const connectionStateMessageId = useMemo(
    () => `account.generator.${connectionState}`,
    [connectionState]
  );

  return (
    <div date-testid="xray-generator-configuration" className="xray-generator-configuration">
      <Dropdown
        value={devicePath || null}
        text={devicePath || null}
        options={serialDevicesOptions}
        onChange={onOptionSelect}
        clearable
        selection
        search
        placeholder={intl.formatMessage({ id: 'account.xray_generator.choose_serial_port' })}
        noResultsMessage={<FormattedMessage id="account.xray_generator.no_serial_port_found" />}
      />
      <div>
        {connectionState === 'connecting' && <Icon name="sync" loading />}
        <FormattedMessage id={connectionStateMessageId} />
      </div>
    </div>
  );
}

export default React.memo(() => {
  const xRayGeneratorManager = useContext(XRayGeneratorManagerContext);
  if (!xRayGeneratorManager) return null;
  return <XRayGeneratorConfiguration />;
});
